//#region src/icon-props.ts
var e = {
	primary: "--icon-color-primary",
	secondary: "--icon-color-secondary",
	tertiary: "--icon-color-tertiary",
	accent: "--icon-color-accent",
	on: "--icon-color-on"
};
function t(t) {
	if (!t) return;
	let n = {};
	for (let r of Object.keys(e)) {
		let i = t[r];
		i != null && i !== "" && (n[e[r]] = i);
	}
	return Object.keys(n).length > 0 ? n : void 0;
}
//#endregion
export { t as mergeIconColorVars };
